const userPlotsStore = {
  state: {
    userPlots: (localStorage.getItem('userPlots'))? JSON.parse(localStorage.getItem('userPlots')):[]
  },
  getters: {
    userPlots(state) {
      return state.userPlots
    },
  },
  actions: {
    addUserPlot (context, plot) {
      let newPlots=[...context.state.userPlots]
      newPlots.push(plot)
      context.commit('setUserPlots', newPlots)
    },
  },
  mutations: {
    setUserPlots (state, userPlots) {
      state.userPlots = userPlots
      localStorage.setItem('userPlots', JSON.stringify(userPlots))
    }
  }
}

export default userPlotsStore
